if( ! document.getElementById("resumeModal") ) {
    return;
}

// Get modal elements for resume and cover letter
const resumeModal = document.getElementById("resumeModal");
const coverLetterModal = document.getElementById("coverLetterModal");

// Get open buttons for both modals
const openModalBtns = document.querySelectorAll(".openModalBtn");

// Get close buttons for both modals
const closeModalBtns = document.querySelectorAll(".close, .closeModalBtn2");

// Open the respective modal when the open button is clicked
openModalBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        // Check which button was clicked and open the corresponding modal
        const buttonName = btn.name;
        
        if (buttonName === "add-resume") {
            const heading = document.querySelector('#resumeModal .custom-modal-header h3');
            if (heading) {
                heading.textContent = 'Add Resume';
            }
            resumeModal.style.display = "block"; // Open the resume modal
        } else if (buttonName === "add-cover-letter") {
            const heading = document.querySelector('#coverLetterModal .custom-modal-header h3');
            if (heading) {
                heading.textContent = 'Add Cover Letter';
            }
            coverLetterModal.style.display = "block"; // Open the cover letter modal
        }
    });
});

// Close the modal when the close button is clicked
closeModalBtns.forEach(btn => {
    btn.addEventListener('click', function() {
        // Close both modals
        resumeModal.style.display = "none";
        coverLetterModal.style.display = "none";
    });
});

// Close the modal if the user clicks outside of it
window.addEventListener('click', function(event) {
    if (event.target === resumeModal) {
        resumeModal.style.display = "none";
    }
    if (event.target === coverLetterModal) {
        coverLetterModal.style.display = "none";
    }
});
